<!--
  <el-select v-model="filterForm.resource" style="width: 180px" collapse-tags multiple>
    <select-all-option v-model="filterForm.resource" :options="resourceOption" />
    <el-option
      v-for="item in resourceOption"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>

import SelectAllOption from '/src/components/common/select-all-option.vue'
components: {SelectAllOption},
-->
<template>
  <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" class="d-block px-2" @change="onChange">全选</el-checkbox>
</template>

<script>
import {watch, ref} from 'vue'

export default {
  props: {
    modelValue: Array,
    options: Array,
  },

  setup(props, {emit}) {
    let isIndeterminate = ref(false),
      checkAll = ref(false)

    function onChange(checkAll) {
      if (checkAll) {
        emit('update:modelValue', props.options.map(item => item.value))
      } else {
        emit('update:modelValue', [])
      }
    }

    watch(() => props.modelValue, (val) => {
      if (val.length === 0) {
        checkAll.value = false
        isIndeterminate.value = false
      } else if (val.length == props.options.length) {
        checkAll.value = true
        isIndeterminate.value = false
      } else {
        checkAll.value = false
        isIndeterminate.value = true
      }
    }, {immediate: true})

    return {checkAll, isIndeterminate, onChange}
  }
}
</script>